import { render, staticRenderFns } from "./OffersBody.vue?vue&type=template&id=94908a58&scoped=true&"
import script from "./OffersBody.vue?vue&type=script&lang=js&"
export * from "./OffersBody.vue?vue&type=script&lang=js&"
import style0 from "./OffersBody.vue?vue&type=style&index=0&id=94908a58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94908a58",
  null
  
)

export default component.exports